declare global {
  interface Window {
    ue?: {
      trigger: (name: string, treatment: string) => void;
    };
  }
}

export type Metadata = {
  weblabs: Record<string, string>;
};

export const logMetadata = (metadata: Metadata): void => {
  try {
    if (typeof window !== 'undefined') {
      Object.entries(metadata.weblabs).forEach(([treatment, value]) => {
        //See: https://w.amazon.com/bin/view/ClientSideMetrics/WeblabClientSideTriggering/UserDocs/
        window?.ue?.trigger(treatment, value);
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error triggering CSM weblab treatment', error);
  }
};
